import revive_payload_client_4sVQNw7RlN from "/workspace/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/workspace/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/workspace/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import browser_devtools_timing_client_tuAbkkkV0J from "/workspace/node_modules/nuxt/dist/app/plugins/browser-devtools-timing.client.js";
import payload_client_yVLowv6hDl from "/workspace/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/workspace/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/workspace/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/workspace/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/workspace/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/workspace/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_I4dbrL2rYz from "/workspace/node_modules/@sidebase/nuxt-auth/dist/runtime/plugin.js";
import primevue_plugin_egKpok8Auk from "/workspace/.nuxt/primevue-plugin.mjs";
import plugin_client_XxbS7tGyhp from "/workspace/node_modules/@primevue/nuxt-module/dist/runtime/plugin.client.js";
import plugin_client_LcKgStRyi6 from "/workspace/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import apex_charts_client_upuglicTA6 from "/workspace/layers/admin-panel/plugins/apex-charts.client.ts";
import vue_grid_client_aR7ZlmFTI9 from "/workspace/layers/admin-panel/plugins/vue-grid.client.ts";
import trpc_client_zjn3rUe7yg from "/workspace/layers/trpc/plugins/trpc-client.ts";
import vue_query_wrmMkNpEpe from "/workspace/plugins/vue-query.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  browser_devtools_timing_client_tuAbkkkV0J,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_I4dbrL2rYz,
  primevue_plugin_egKpok8Auk,
  plugin_client_XxbS7tGyhp,
  plugin_client_LcKgStRyi6,
  apex_charts_client_upuglicTA6,
  vue_grid_client_aR7ZlmFTI9,
  trpc_client_zjn3rUe7yg,
  vue_query_wrmMkNpEpe
]